import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/hooks/useAuth";
import { AuthGuard } from "@/components/layout/AuthGuard";
import Login from "@/pages/Login";
import ChatShell from "@/pages/ChatShell";
import Logs from "@/pages/Logs";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public */}
          <Route path="/login" element={<Login />} />

          {/* Protected */}
          <Route element={<AuthGuard />}>
            <Route path="/" element={<ChatShell />} />
            <Route path="/chat/:projectId" element={<ChatShell />} />
            <Route path="/logs" element={<Logs />} />
          </Route>

          {/* Legacy redirect */}
          <Route path="/projects" element={<Navigate to="/" replace />} />

          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
